import { IResponse, API, consumer, Headers } from "@bemap/utils"

export const resetPassword = async (id: number): Promise<IResponse> => {
  return await consumer('POST', `/users/${id}/reset-password`, {})
}

export const userAskResetPassword = async (email: string): Promise<IResponse> => {
  return await consumer('POST', `/auth/reset-password`, { email })
}

export const verify = async (email: string, otp: string): Promise<boolean> => {
  const payload = {
    email,
    otp,
  }

  const { data } = await API.post('/auth/confirm-reset-password', payload, await Headers.normal());
  if (Boolean(data?.token)) {
    localStorage.setItem("token", data?.token);
  }

  return Boolean(data?.token)
}

export const userResetChangePassword = async (x: string): Promise<IResponse> => {
  return await consumer('POST', `/users/reset-change-password`, { x })
} 